import { DocumentExecutionService } from '@services/actions/DocumentExecutionService';
import { AttachmentsArchiveExecutor } from '../parts/AttachmentsArchiveExecutor';

export class DownloadLinkedDocumentsAttachmentsExecutor extends AttachmentsArchiveExecutor {
    protected readonly syncRoute = 'downloadLinkedDocumentsAttachments';

    protected startInBackground(service: DocumentExecutionService, actionKey: string) {
        return service.startLinkedDocumentsAttachmentsInBackground(actionKey);
    }
}
